export const easeOut = [0.22, 1, 0.36, 1];

export const fadeUp = {
  hidden: { opacity: 0, y: 26 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: easeOut } },
};

export const stagger = (delay = 0.09) => ({
  hidden: {},
  show: { transition: { staggerChildren: delay } },
});

export const viewport = { once: true, margin: "-80px" };
